import { Switch } from "@mui/material";
import styles from "../../tenantdetails.module.css";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";

const PermissionsTab = ({ tenantData, setTenantData, setLoading, setSnackbarOpen, setSnackbarMsg }) => {
    const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
    const [defaultAppPerms, setDefaultAppPerms] = useState({ chat: false, energy: false, payments_acf: false, payments_card: false, request: false, smart_rooms: false, sos: false, parking_gate: false, parking_gate_door: false });
    const [changedAppPerms, setChangedAppPerms] = useState({ chat: false, energy: false, payments_acf: false, payments_card: false, request: false, smart_rooms: false, sos: false, parking_gate: false, parking_gate_door: false });
    const [defaultDeactiveSwitchs, setDefaultDeactiveSwitchs] = useState(null);
    const [changedDeactiveSwitchs, setChangedDeactiveSwitchs] = useState(null);
    const [defaultFlexPaySwitch, setDefaultFlexPaySwitch] = useState(false);
    const [changedFlexPaySwitch, setChangedFlexPaySwitch] = useState(false);
    const [defaultAppAccessSwitch, setDefaultAppAccessSwitch] = useState(false);
    const [changedAppAccessSwitch, setChangedAppAccessSwitch] = useState(false);

    const { register, handleSubmit } = useForm({
        shouldUnregister: false,
    });

    const { register: register1, handleSubmit: handleSubmit1 } = useForm({
        shouldUnregister: false,
    });

    const { register: register2, handleSubmit: handleSubmit2 } = useForm({
        shouldUnregister: false,
    });

    const { handleSubmit: handleSubmit3 } = useForm({
        shouldUnregister: false,
    });

    useEffect(() => {
        if (tenantData?.app_permissions) {
            setDefaultAppPerms(prev => {
                return { ...prev, ...tenantData?.app_permissions }
            });
            setChangedAppPerms(prev => {
                return { ...prev, ...tenantData?.app_permissions }
            });
        }

        if (tenantData?.all_tenants) {
            let statusArr = tenantData?.all_tenants?.map(item => {
                return item?.is_deactive === 1;
            });
            setDefaultDeactiveSwitchs(statusArr);
            setChangedDeactiveSwitchs(statusArr);

            let hasAppAccess = tenantData?.all_tenants?.length > 0 && tenantData?.all_tenants?.every(item => {
                return item?.app_status === 1;
            });
            setDefaultAppAccessSwitch(hasAppAccess);
            setChangedAppAccessSwitch(hasAppAccess);
        }

        if (tenantData?.is_flex_pay && tenantData?.is_flex_pay === 1) {
            setDefaultFlexPaySwitch(true);
            setChangedFlexPaySwitch(true);
        }

    }, [tenantData]);

    const onSubmit = async (data) => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.put(process.env.REACT_APP_TENANT_API_URL + "v1/tenants/" + tenantData?.id + "/update-permission", data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            setTenantData(prev => {
                return { ...prev, app_permissions: response.data.data };
            });
        }).catch((error) => {
            setLoading(false);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    const onSubmit2 = async (data) => {
        let statusData = tenantData?.all_tenants?.map((item, index) => {
            return { id: item?.id, is_deactive: data?.tenants[index] ? 1 : 0 };
        });

        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.post(process.env.REACT_APP_TENANT_API_URL + "v1/tenants/update-status", { status: statusData }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            setTenantData(prev => {
                let all_tenants = prev?.all_tenants?.map((item, index) => {
                    return { ...item, is_deactive: data?.tenants[index] ? 1 : 0 };
                });
                return { ...prev, all_tenants: all_tenants };
            });
        }).catch((error) => {
            setLoading(false);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    const onSubmit3 = async (data) => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        let flexPayCng = changedFlexPaySwitch ? 1 : 0;

        return axios.put(process.env.REACT_APP_TENANT_API_URL + "v1/tenants/update-flex-settings/" + tenantData?.id, { is_flex_pay: flexPayCng }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            setTenantData(prev => {
                return { ...prev, is_flex_pay: flexPayCng };
            });
        }).catch((error) => {
            setLoading(false);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    const onSubmit4 = async () => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        // Enabling grants full access; disabling turns off app_status and the backend restores lease/payment flags
        let appAccessPayload = changedAppAccessSwitch ? { app_status: 1, lease_status: 1, payment_status: 1 } : { app_status: 0 };

        return axios.put(process.env.REACT_APP_TENANT_API_URL + "v1/tenants/" + tenantData?.id + "/update-app-access", appAccessPayload, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            setTenantData(prev => {
                let all_tenants = prev?.all_tenants?.map(item => {
                    let updated = response.data.data?.find(subItem => subItem?.id === item?.id);
                    return updated ? { ...item, ...updated } : item;
                });
                return { ...prev, all_tenants: all_tenants };
            });
        }).catch((error) => {
            setLoading(false);
            setChangedAppAccessSwitch(defaultAppAccessSwitch);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    const checkBalance = () => {
        if (tenantData?.balance > 0) {
            toast.error("Clear balance to enable Flex Pay");
            return false;
        }

        return true;
    }

    return <div className={`${styles.Permission}`}>
        <h5>Mobile App Access</h5>

        <form onSubmit={handleSubmit3(onSubmit4)}>
            <div className={`${styles.TabSecMain}`}>
                <div className={`${styles.PermissionSwitch}`}>
                    <Switch
                        name="is_app_access"
                        onChange={(e) => {
                            setChangedAppAccessSwitch(e.target.checked);
                        }}
                        checked={changedAppAccessSwitch}
                        disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant-permission:update") > -1)}
                    />
                    Allow App Access
                </div>
                {(defaultAppAccessSwitch !== changedAppAccessSwitch) && <button type="submit" className={`${styles.ButtonVoiletSolidSM}`}>Apply</button>}
            </div>
        </form>

        <h5>Mobile App Permissions</h5>

        <form onSubmit={handleSubmit(onSubmit)}>
            <div className={`${styles.TabSecMain}`}>
                <div className={`${styles.PermissionSwitch}`}>
                    <Switch
                        onChange={(e) => {
                            setChangedAppPerms(prev => {
                                return { ...prev, smart_rooms: e.target.checked }
                            });
                        }}
                        name="smart_rooms"
                        inputRef={register}
                        checked={changedAppPerms?.smart_rooms === true}
                        disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant-permission:update") > -1)}
                    />
                    Smart Rooms
                </div>
                <div className={`${styles.PermissionSwitch}`}>
                    <Switch
                        onChange={(e) => {
                            setChangedAppPerms(prev => {
                                return { ...prev, request: e.target.checked }
                            });
                        }}
                        name="request"
                        inputRef={register}
                        checked={changedAppPerms?.request === true}
                        disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant-permission:update") > -1)}
                    />
                    Requests
                </div>
                <div className={`${styles.PermissionSwitch}`}>
                    <Switch
                        onChange={(e) => {
                            setChangedAppPerms(prev => {
                                return { ...prev, energy: e.target.checked }
                            });
                        }}
                        name="energy"
                        inputRef={register}
                        checked={changedAppPerms?.energy === true}
                        disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant-permission:update") > -1)}
                    />
                    Lease
                </div>
                <div className={`${styles.PermissionSwitch}`}>
                    <Switch
                        onChange={(e) => {
                            setChangedAppPerms(prev => {
                                return { ...prev, payments_card: e.target.checked }
                            });
                        }}
                        name="payments_card"
                        inputRef={register}
                        checked={changedAppPerms?.payments_card === true}
                        disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant-permission:update") > -1)}
                    />
                    View Payments
                </div>
                <div className={`${styles.PermissionSwitch}`}>
                    <Switch
                        onChange={(e) => {
                            setChangedAppPerms(prev => {
                                return { ...prev, payments_acf: e.target.checked }
                            });
                        }}
                        name="payments_acf"
                        inputRef={register}
                        checked={changedAppPerms?.payments_acf === true}
                        disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant-permission:update") > -1)}
                    />
                    ACH Payment
                </div>
                <div className={`${styles.PermissionSwitch}`}>
                    <Switch
                        onChange={(e) => {
                            setChangedAppPerms(prev => {
                                return { ...prev, chat: e.target.checked }
                            });
                        }}
                        name="chat"
                        inputRef={register}
                        checked={changedAppPerms?.chat === true}
                        disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant-permission:update") > -1)}
                    />
                    Chat
                </div>
                <div className={`${styles.PermissionSwitch}`}>
                    <Switch
                        onChange={(e) => {
                            setChangedAppPerms(prev => {
                                return { ...prev, sos: e.target.checked }
                            });
                        }}
                        name="sos"
                        inputRef={register}
                        checked={changedAppPerms?.sos === true}
                        disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant-permission:update") > -1)}
                    />
                    Emergency SOS
                </div>
                <div className={`${styles.PermissionSwitch}`}>
                    <Switch
                        onChange={(e) => {
                            setChangedAppPerms(prev => {
                                return { ...prev, parking_gate: e.target.checked }
                            });
                        }}
                        name="parking_gate"
                        inputRef={register}
                        checked={changedAppPerms?.parking_gate === true}
                        disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant-permission:update") > -1)}
                    />
                    Parking Gate Control
                </div>
                <div className={`${styles.PermissionSwitch}`}>
                    <Switch
                        onChange={(e) => {
                            setChangedAppPerms(prev => {
                                return { ...prev, parking_gate_door: e.target.checked }
                            });
                        }}
                        name="parking_gate_door"
                        inputRef={register}
                        checked={changedAppPerms?.parking_gate_door === true}
                        disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant-permission:update") > -1)}
                    />
                    Parking Gate Door Control
                </div>
                {(JSON.stringify(defaultAppPerms) !== JSON.stringify(changedAppPerms)) && <button type="submit" className={`${styles.ButtonVoiletSolidSM}`}>Apply</button>}
            </div>
        </form>

        <h5>Deactivate Mobile App Login</h5>

        <form onSubmit={handleSubmit1(onSubmit2)}>
            <div className={`${styles.TabSecMain}`}>
                {tenantData?.all_tenants?.map((item, index) => {
                    return <div className={`${styles.PermissionSwitch}`}>
                        <Switch
                            name={`tenants.${index}`}
                            inputRef={register1}
                            onChange={(e) => {
                                setChangedDeactiveSwitchs(prev => {
                                    return prev?.map((subItem, subIndex) => {
                                        if (subIndex === index)
                                            return e.target.checked;
                                        return subItem;
                                    });
                                });
                            }}
                            defaultChecked={item?.is_deactive === 1}
                            disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant-permission:update") > -1)}
                        />
                        {item?.full_name}
                    </div>
                })}
                {(JSON.stringify(defaultDeactiveSwitchs) !== JSON.stringify(changedDeactiveSwitchs)) && <button type="submit" className={`${styles.ButtonVoiletSolidSM}`}>Apply</button>}
            </div>
        </form>

        <h5>Flex Pay Settings</h5>

        <form onSubmit={handleSubmit2(onSubmit3)}>
            <div className={`${styles.TabSecMain}`}>
                <div className={`${styles.PermissionSwitch}`}>
                    <Switch
                        name={`is_flex_pay`}
                        inputRef={register2}
                        onChange={(e) => {
                            if (e.target.checked && checkBalance()) {
                                setChangedFlexPaySwitch(e.target.checked);
                            }
                            if (!e.target.checked) {
                                setChangedFlexPaySwitch(e.target.checked);
                            }
                        }}
                        checked={changedFlexPaySwitch}
                        disabled={!(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("tenant-permission:update") > -1)}
                    />
                    Allow Flex Pay
                </div>
                {(defaultFlexPaySwitch !== changedFlexPaySwitch) && <button type="submit" className={`${styles.ButtonVoiletSolidSM}`}>Apply</button>}
            </div>
        </form>
    </div >
}

export default PermissionsTab;